/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      //console.log('Container ———————— ↓');
      //console.log(container);
      //console.log('Variant —————————— ↓');
      //console.log(variant);
      // ... update some element on the page
    }
  });
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      //console.log('Cart ———————————— ↓');
      //console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    //console.log('theme:cart:init');
    //console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
  //document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
jQuery(document).ready(function() {
var button = jQuery('.btn--add-to-cart .btn-state-ready');

    var dataText = button.data('text');
    if (dataText) { 
        button.find('span').text('Pre-order');
    }

  var button = $('.btn--add-to-cart .btn-state-ready');
  jQuery('.select-popout__list .select-popout__option').on('click', function() {
    var dataText = button.data('text');
    if (dataText) {
      button.find('span').text('Pre-order');
    }

    // Optionally, update the current selected item
    jQuery('.select-popout__list .select-popout__item').removeClass('select-popout__item--current');
    jQuery(this).closest('li').addClass('select-popout__item--current');
  });
});

jQuery('.btn--add-to-cart').on('click', function() {
    setTimeout(function() {
        if ($('.product-add-popdown').hasClass('is-visible')) {
            const cartLink = $('.product__popdown__cart__wrapper').find('a');
            if (cartLink.length) {
                cartLink[0].click();
            }
        }
    }, 2000); 
});



    jQuery(document).ready(function() {
        if (/Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor) && !/Chrome/.test(navigator.userAgent)) {
            jQuery('body').addClass('safari');
        }
    });






 document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      // Select the button with the specific aria-label
      const button = document.querySelector('button[aria-label="Limited quantity"]');

      if (button) {
        // Remove the 'disable' class
        button.classList.remove('disable');

        // Enable the button by removing the 'disabled' attribute
        button.removeAttribute('disabled');
      }
    }, 2000); // 2000ms = 2 seconds
  });


    document.addEventListener('DOMContentLoaded', function() {
    if (typeof jQuery !== 'undefined') {
      jQuery('.gallery-images').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
         autoplay: true,   
          autoplaySpeed: 2000,  
          
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  });
 
 
  
